import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetActiveSpocProjectsRPC } from "./getActiveSpocProjectsRPC";

export class GetActiveSpocProjectsRPCClientImpl extends GetActiveSpocProjectsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetActiveSpocProjectsRPC.Request): Promise<LeoRPCResult<GetActiveSpocProjectsRPC.Response, GetActiveSpocProjectsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetActiveSpocProjects",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetActiveSpocProjectsRPC.ResponseDTO,
      GetActiveSpocProjectsRPC.Errors.ErrorsDTO,
      GetActiveSpocProjectsRPC.Response,
      GetActiveSpocProjectsRPC.Errors.Errors
    >(
      response,
      "project/GetActiveSpocProjects",
      GetActiveSpocProjectsRPC.Response.fromDTO,
      GetActiveSpocProjectsRPC.Errors.fromDTO
    );
  }
}
